import { localStore } from 'utils/storage'
import { migrateLegacyLauncherKeys } from '../hooks/use-floating-button-position'
import {
  AIDA_DOCK_WIDTH_STORAGE_KEY,
  LEGACY_AIDA_DOCK_WIDTH_KEY,
} from '../utils/constants/storage-keys'
import { migrateLegacyIntroSeen } from '../utils/intro-seen'
import { migrateLegacyOverlaySession } from './overlay-session'

function migrateLegacyDockWidth() {
  const stored = localStore.getString(AIDA_DOCK_WIDTH_STORAGE_KEY)
  const legacy = localStore.getString(LEGACY_AIDA_DOCK_WIDTH_KEY)
  if (stored === null && legacy !== null) {
    localStore.setString(AIDA_DOCK_WIDTH_STORAGE_KEY, legacy)
  }
  localStore.remove(LEGACY_AIDA_DOCK_WIDTH_KEY)
}

export function migrateLegacyAidaKeys() {
  migrateLegacyOverlaySession()
  migrateLegacyDockWidth()
  migrateLegacyLauncherKeys()
  migrateLegacyIntroSeen()
}
